export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => { var _a; return resolve((_a = reader.result) === null || _a === void 0 ? void 0 : _a.replace(/^data:.+;base64,/, '')); };
        reader.onerror = (error) => reject(error);
    });
};
